import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "home",
  "title": "Scoping Progress in Education",
  "lead": "Education lights every stage of the journey to a better life. To unlock the wider benefits of education, all children need access to education of good quality. Special efforts are needed to ensure that all children and young people – regardless of their family income, where they live, their gender, their ethnicity, whether they are disabled – can benefit equally from its transformative power. This requires sufficient resources, especially to reach those who need more support."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {HighlightByTheme, IndexHero, LandingButton, LandingText, PageLink, RelatedContent, ThemeLinks} = _components;
  if (!HighlightByTheme) _missingMdxReference("HighlightByTheme", true);
  if (!IndexHero) _missingMdxReference("IndexHero", true);
  if (!LandingButton) _missingMdxReference("LandingButton", true);
  if (!LandingText) _missingMdxReference("LandingText", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedContent) _missingMdxReference("RelatedContent", true);
  if (!ThemeLinks) _missingMdxReference("ThemeLinks", true);
  return _jsxs(_Fragment, {
    children: [_jsxs(IndexHero, {
      children: [_jsx(_components.h1, {
        id: "scoping-progress-in-education",
        children: "Scoping Progress in Education"
      }), _jsxs(_components.p, {
        children: ["Education lights every stage of the journey to a better life. All children need ", _jsx(HighlightByTheme, {
          theme: "access",
          children: "access"
        }), " to education of good ", _jsx(HighlightByTheme, {
          theme: "quality",
          children: "quality"
        }), " to unlock their ", _jsx(HighlightByTheme, {
          theme: "learning",
          children: "learning"
        }), " potential and the wider benefits of education. Special efforts are needed to ensure that all children and young people can benefit ", _jsx(HighlightByTheme, {
          theme: "equity",
          children: "equally"
        }), " from its transformative power. This requires sufficient ", _jsx(HighlightByTheme, {
          theme: "finance",
          children: "resources"
        }), ", especially to reach those who need more support."]
      })]
    }), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["In 2015, the international community included a goal on education, ", _jsx(_components.a, {
          href: "https://sustainabledevelopment.un.org/sdg4",
          children: "SDG 4"
        }), ", among the 17 Sustainable Development Goals to be achieved by 2030. Since then, an ", _jsx(PageLink, {
          name: "indicators",
          children: "elaborate framework"
        }), " has been put in place to monitor progress towards the targets in the goal. Scoping Progress in Education (SCOPE) summarizes the key facts and trends in education around the world through five themes:"]
      })
    }), "\n", _jsx(ThemeLinks, {}), "\n", _jsx(LandingText, {
      children: _jsxs(_components.p, {
        children: ["It complements the information that is provided in the printed version of the ", _jsx(_components.a, {
          href: "https://en.unesco.org/gem-report/allreports",
          children: "Global Education Monitoring Report"
        }), ", the tool of the international community for the follow up and review of progress towards our education goal, SDG 4."]
      })
    }), "\n", _jsx(LandingButton, {
      children: "Start reading"
    }), "\n", _jsx(RelatedContent, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
